import ErrorBoundary from "components/ErrorBoundary";
import React from "react";
import { dequal } from "dequal/lite";
import {
  UnstyledBlockContent,
  UnstyledBlockContentProps
} from "@silversea-ssc/ui-components-react";

export type BlockContentProps = UnstyledBlockContentProps;

const BlockContent: React.FC<React.PropsWithChildren<BlockContentProps>> = (
  props
) => {
  return (
    <ErrorBoundary>
      <UnstyledBlockContent {...props} />
    </ErrorBoundary>
  );
};

export default React.memo(BlockContent, dequal);
